import { React,useEffect } from "react"
// NEW UI: The active root route uses the redesigned landing page; the legacy page is retained unchanged.
import LandingPage from "./Pages/Pre Launch Page/LandingPageNew";
import Main from "./Pages/Main";
import { Routes, Route } from "react-router-dom";
import GrantProfileForm from "./Pages/grantprofileform";
import ProposalDashboard from "./Pages/Dashboards/proposal-dashboard";
import Login from "./Pages/Registration/login";
import Signup from "./Pages/Registration/signup";
import NewProposalDashboard from "./Pages/Dashboards/new-proposal-dashboard";
import TermsOfService from "./Pages/Termspages/termsofservice";
import PrivacyPolicy from "./Pages/Termspages/privacypolicy";
import DataProcessingAgreement from "./Pages/Termspages/dataprocessing";
import { SubscriptionProvider } from "./Contexts/SubscriptionContext";
import AffiliatePage from "./Pages/Affiliate";
import { ToastContainer } from "react-toastify";
import useSaveAffiliateId from "./hooks/useSaveAfilliateId";
import ClientProposalDashboard from "./Pages/Dashboards/ClientProposalDashboard";
import ResetPassword from "./Pages/Registration/resetPassword";
import 'react-toastify/dist/ReactToastify.css';
import { GrantFilterProvider } from './Pages/grantaide-database-site/Filter/GrantFilterProvider';
import FilterDataProvider from './Pages/grantaide-database-site/Filter/FilterDataProvider';
import fireStore from './Pages/grantaide-database-site/utilities/Firestore';
import GrantaideDatabaseSite from './Pages/grantaide-database-site';
import { AuthProvider } from './Pages/grantaide-database-site/AuthContext';
import CheckEligibility from "./Pages/CheckEligibility";


function DatabaseLayout({ children }) {
  useEffect(() => {
    const prevColor = document.body.style.backgroundColor;
    document.body.style.backgroundColor = "white";
    return () => {
      document.body.style.backgroundColor = prevColor; // restore on exit
    };
  }, []);
  return (
    <AuthProvider>
    <fireStore.Provider>
      <FilterDataProvider>
        <GrantFilterProvider>{children}</GrantFilterProvider>
      </FilterDataProvider>
    </fireStore.Provider>
    </AuthProvider>
  );
}


function App() {

  useSaveAffiliateId();



  return (
    <div className="App">
      <ToastContainer />
      <SubscriptionProvider>
        <Routes>
          <Route exact path="/affiliate" element={<AffiliatePage />} />
          <Route 
            path="/grant-assistant/:clientId/:grantId" 
            element={<Main />} 
          />
          <Route exact path="/" element={<LandingPage />} />
          <Route exact path="/proposal-dashboard" element={<ProposalDashboard />} />
          <Route exact path="/form" element={<GrantProfileForm />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/reset-password" element={<ResetPassword />} />
          <Route exact path="/signup" element={<Signup />} />
          <Route exact path="/all-client-dashboard" element={<ClientProposalDashboard />} />
          <Route exact path="/new-proposal-dashboard" element={<NewProposalDashboard />} />
          <Route exact path="/termsofservice" element={<TermsOfService />} />
          <Route exact path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route exact path="/data-processing-agreement" element={<DataProcessingAgreement />} />
          <Route exact path="/check-eligibility" element={<CheckEligibility />} />
          <Route
        path="/grant-database"
        element={
          <DatabaseLayout>
            <GrantaideDatabaseSite />
          </DatabaseLayout>
        }
      />
        </Routes>
      </SubscriptionProvider>
    </div>
  );
}

export default App;
